import useConfig from 'hooks/useConfig';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import Box from '@mui/material/Box';

import { USER_ROLES } from 'utils/role-utils';
import RoleGuard from 'utils/route-guard/RoleGuard';

interface Props {
  onlySpanish?: boolean;
}

export default function WaiterLayout({ onlySpanish = false }: Props) {
  const { i18n, onChangeLocalization } = useConfig();

  useEffect(() => {
    if (i18n !== 'es' && onlySpanish) {
      onChangeLocalization('es');
    }
  }, [i18n, onChangeLocalization, onlySpanish]);

  return (
    <RoleGuard allowedRoles={[USER_ROLES.WAITER]}>
      <Box>
        <Outlet />
      </Box>
    </RoleGuard>
  );
}
